export default '1.0.0-beta.1';
